import React from 'react';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from "@material-ui/core/styles";
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import HeroStories from "./HeroStories";
import ThankyouNotes from "./ThankyouNotes";
import Container from "@material-ui/core/Container";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
    tabs: {
      marginTop: theme.spacing(3),
    },
    cardMedia: {
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
  }
));

export default function Occupation(props) {
  const classes = useStyles();
  const { occupation, goBack } = props;
  const [tabValue, setTabValue] = React.useState(0);

  return (
    <Container maxWidth="md">
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
        <Link color="inherit" href="/" onClick={goBack}>
          All Heros
        </Link>
        <div>
          <ListItem>
            <ListItemIcon>
              <img src={occupation.image} width="50" height="50" className={classes.cardMedia} alt="Hero"/>
            </ListItemIcon>
            <ListItemText primary={<Typography color="secondary"><b>{occupation.title}</b></Typography>} />
          </ListItem>
        </div>
      </Breadcrumbs>
      <Tabs
        value={tabValue}
        indicatorColor="secondary"
        textColor="secondary"
        className={classes.tabs}
        onChange={(event, newValue) => setTabValue(newValue)}
      >
        <Tab label={<Typography variant={"subtitle1"}>Hero Stories</Typography> } />
        <Tab label={<Typography variant={"subtitle1"}>Thank you Notes</Typography> } />
      </Tabs>
      <TabPanel value={tabValue} index={0}>
        <HeroStories hero={occupation}/>
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <ThankyouNotes/>
      </TabPanel>
    </Container>
  );
}
